import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { useConsultModal } from "@/components/ConsultModal";
import { ArrowRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

const mental = ["Anxiety", "Stress", "Depression", "Burnout", "Trauma", "PTSD", "Grief", "Relationships"];
const cognitive = ["Focus", "Memory", "Brain Fog", "Executive Function", "ADHD Concerns", "Neurological Conditions", "Cognitive Performance"];

export default function CouchHowItWorks() {
  const { open: openConsult } = useConsultModal();
  return (
    <Page>
      <Seo title="How Couch Works · Therapy in 4 Steps" description="How MindDhara Couch works — from free consultation to matched therapist to ongoing care." />
      <section className="md-section md-page-hero" data-testid="couch-hiw-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Couch · How It Works</div>
          <h1 className="text-5xl md:text-6xl font-serif mb-4 max-w-3xl mx-auto" data-testid="couch-hiw-title">
            Know what you <em style={{ color: "#f4fa9c", fontStyle: "italic" }}>need?</em>
          </h1>
          <p className="text-base md:text-lg max-w-2xl mx-auto" data-testid="couch-hiw-subtitle">
            Choose a pathway and start immediately.
          </p>
        </div>
      </section>

      <section className="md-section pt-0">
        <div className="md-container">
          <div className="grid md:grid-cols-2 gap-6 mt-2" data-testid="couch-hiw-pathways">
            <div className="md-card" data-testid="hiw-mental-wellbeing">
              <div className="md-label-eyebrow mb-3">Mental Wellbeing</div>
              <h3 className="text-2xl font-serif mb-4">Support to feel better</h3>
              <div className="flex flex-wrap gap-2">{mental.map((m) => <span key={m} className="md-tag">{m}</span>)}</div>
              <Link to="/therapists?source=couch-hiw-step" className="btn-primary mt-8 text-sm" data-testid="hiw-browse-therapists">
                Browse Therapists <ArrowRight size={14} weight="bold" />
              </Link>
            </div>
            <div className="md-card" data-testid="hiw-cognitive-wellbeing">
              <div className="md-label-eyebrow mb-3">Cognitive Wellbeing</div>
              <h3 className="text-2xl font-serif mb-4">Support to think better</h3>
              <div className="flex flex-wrap gap-2">{cognitive.map((c) => <span key={c} className="md-tag">{c}</span>)}</div>
              <Link to="/couch/cognitive-support?source=couch-hiw-step" className="btn-primary mt-8 text-sm" data-testid="hiw-cognitive-pathway">
                Start Structured Pathway <ArrowRight size={14} weight="bold" />
              </Link>
            </div>
          </div>

          {/* Closing decision panel — dark-green tile, lime eyebrow + white heading for high contrast */}
          <div className="md-card mt-12 text-center md-hiw-close" data-testid="hiw-decide-panel" style={{ background: "var(--md-primary)" }}>
            <div className="md-label-eyebrow mb-3 md-hiw-close-eyebrow" style={{ color: "#f4fa9c" }}>Your Journey Your Way</div>
            <h2 className="text-3xl md:text-4xl font-serif mb-6" style={{ color: "#ffffff" }} data-testid="hiw-decide-title">
              Need help <em style={{ color: "#f4fa9c", fontStyle: "italic" }}>deciding?</em>
            </h2>
            <div className="flex flex-wrap gap-3 justify-center" data-testid="hiw-decide-actions">
              <button onClick={openConsult} className="btn-accent text-sm" data-testid="hiw-cta-consultation">
                Book a Free Consultation <ArrowRight size={14} weight="bold" />
              </button>
              <Link to="/therapists?source=couch-hiw-footer" className="btn-secondary text-sm" data-testid="hiw-cta-browse">
                Browse Therapists <ArrowRight size={14} weight="bold" />
              </Link>
              <Link to="/couch/cognitive-support?source=couch-hiw-footer" className="btn-secondary text-sm" data-testid="hiw-cta-pathway">
                Start Structured Pathway <ArrowRight size={14} weight="bold" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}
